import chunk_1 from './chunk-1.json'

export default [
  ...chunk_1
]
